import styled from "styled-components";
import theme from "../json/theme.json";

// Navigation

export const NavLogoImage = styled.img`
height: ${theme.navigation.logo_height};
margin: 0px 6px;
`